
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 26"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.01 0A12.99 12.99 0 0126 13 13 13 0 1113.01 0zm4.067 7a1.938 1.938 0 00-1.23.448l-.125.113-2.683 2.79-2.773-2.77a1.821 1.821 0 00-1.356-.56c-.508 0-.994.204-1.348.567A1.856 1.856 0 007 8.928c-.01.454.15.893.445 1.232l.117.123 2.827 2.728-2.827 2.715c-.358.36-.56.846-.562 1.353-.01.51.193 1.002.562 1.354a1.938 1.938 0 002.615.113l.123-.113 2.773-2.769 2.656 2.749a1.86 1.86 0 001.369.574 1.83 1.83 0 001.3-.52 1.933 1.933 0 00.114-2.612l-.113-.123-2.704-2.7 2.738-2.736a1.932 1.932 0 000-2.735 1.822 1.822 0 00-1.356-.56z"}})])
          )
        }
      }
    